<template>
    <div>
        <b-row v-if="size === 'md'">
            <b-col cols="5">
            </b-col>
            <b-col cols="6">
                <b-row>
                <b-col cols="5">
                    <md-button @click.stop="cancel"  >{{ $t(cancelButtonLabel ? cancelButtonLabel : 'Cancel') }}</md-button>
                </b-col>
                <b-col cols="5">
                    <md-button @click.stop="save" class="md-raised">{{ $t(saveButtonLabel ? saveButtonLabel : 'Save') }}</md-button>
                </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="size === 'lg'">
            <b-col cols="8">
            </b-col>
            <b-col cols="3">
                <b-row>
                <b-col cols="6">
                    <md-button @click.stop="cancel"  >{{ $t(cancelButtonLabel ? cancelButtonLabel : 'Cancel') }}</md-button>
                </b-col>
                <b-col cols="6">
                    <md-button @click.stop="save" class="md-raised">{{ $t(saveButtonLabel ? saveButtonLabel : 'Save') }}</md-button>
                </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="size === 'xl'">
            <b-col cols="9">
            </b-col>
            <b-col cols="3">
                <b-row>
                <b-col cols="5">
                    <md-button @click.stop="cancel"  >{{ $t(cancelButtonLabel ? cancelButtonLabel : 'Cancel') }}</md-button>
                </b-col>
                <b-col cols="5">
                    <md-button @click.stop="save" class="md-raised">{{ $t(saveButtonLabel ? saveButtonLabel : 'Save') }}</md-button>
                </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md'
    },
    isLgModal: false,
    saveButtonLabel: null,
    cancelButtonLabel: null
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    save () {
      this.$emit('save')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/modalOkCancel.vue